import { Injectable } from '@angular/core';
import {
  API_METHODS,
  API_URL,
  OperationType,
} from 'common/constants/sm-constants';
import { environment } from 'src/environments/environment';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';

import { CompanyModel } from 'common/models/page-models/internship-company/internship-company/internship-company-data.model';
import { postCompany } from 'common/models/page-models/internship-company/internship-company/internship-company-form-meta.model';
import { FormDataService } from '../../base-data-services/form-data.service';

@Injectable({
  providedIn: 'root',
})
export class CompanyFormDataService extends FormDataService<CompanyModel> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.internshipCompanyFormAdd, http, ss);
  }
  override getEditUrlAndMethod() {
    const edit = {
      url: environment.apiUrl + API_URL.internshipCompanyViewDetails,
      method: API_METHODS.post,
    };
    return edit;
  }

  override getUpdatePayload(data: any) {
    let payload = {
      id: data.id,
    };

    return payload;
  }

  override getPostDataType(): boolean {
    return false;
  }

  override afterGetData(model: CompanyModel): Promise<CompanyModel> {
    return new Promise<any>((resolve, reject) => {
      model.id = model.internshipCompanyId;
      resolve(model);
    });
  }

  override beforePostData(
    model: any,
    metamodel: any,
    dataModel: any
  ): Promise<CompanyModel> {
    return new Promise<any>((resolve, reject) => {
      const submitData: any = new postCompany();
      submitData.companyName = model.companyName;
      if (
        dataModel.internshipCompanyId !== null &&
        dataModel.internshipCompanyId !== ''
      ) {
        submitData.id = dataModel.internshipCompanyId;
      }
      //  submitData.companyLocation = model.companyLocation;
      submitData.companyLocation = model.companyLocation.map(
        (location: any) => {
          return {
            ...location,
            internRequired: parseInt(location.internRequired, 10) || 0,
          };
        }
      );
      submitData.companyMentor = model.companyMentor;
      submitData.considerYear = model.year;

      // console.log(submitData);
      resolve(submitData);
    });
  }

  // override getUpdateUrl() {
  //   return API_URL.internshipCompanyFormEdit;
  //   }

  //     override getOperationType(data: any) {
  //   if (data.hasOwnProperty('internshipCompanyId')) {
  //     return data.internshipCompanyId !== '' ? OperationType.UPDATE : OperationType.CREATE;
  //   } else {
  //     return OperationType.CREATE;
  //   }
  // }

  // override async postData(data): Promise<any> {
  //     return await new Promise((resolve, reject) => {
  //         let type;
  //         if(data.internshipCompanyId){
  //             type= OperationType.UPDATE;
  //         }
  //         else{
  //           type = this.getOperationType(data);
  //         }
  //         const url = this.generateUrl(type);
  //       this.apiService
  //         .postData(url, data)
  //         .then((res) => {
  //           resolve(res);
  //         })
  //         .catch((err) => {
  //           reject(err);
  //         });
  //     });
  //   }

  //   override generateUrl(type: OperationType, paramKey?: any, extraKey?: any) {

  //     return environment.apiUrl + API_URL.internshipCompanyFormEdit;
  //   }

  override modifyAPIResponse(response: any) {
    const dataModel = this.createInstance();
    dataModel.companyName = response?.details?.companyName;
    dataModel.year = response?.details?.considerYear;
    dataModel.companyLocation =
      response?.details?.internshipCompanyLocationData;
    dataModel.companyMentor = response?.details?.internshipCompanyMentorData;
    dataModel.internshipCompanyId = response?.details?.id;

    return dataModel;
  }

  createInstance(): CompanyModel {
    return new CompanyModel();
  }

  override updatepostUrl() {
    return environment.apiUrl + API_URL.internshipCompanyFormAdd;
  }
}

export { FormDataService };
